export default "__VITE_ASSET__5f8f6356__"